import React, {VoidFunctionComponent} from "react";
import { Toggle } from "@/components/responsive/toggle/Toggle";
import { ProductDiscountDetails } from "@/models/scope/productSheet/ProductDiscountDetails";
import Utils from "@/libs/Utils";
import {SOLD_BY_MKP} from "@/utils/constants";

interface Props {
    showWithoutTaxOptin: boolean;
    setPriceIncludeVAT: (includeVAT: boolean) => void;
    soldBy: string;
    datePrixBarreMkp: boolean;
    priceIncludeVAT: boolean;
    endDateRI: string;
    eligibilityToPrivateSale: boolean;
    privateSalePrice: number | null;
    privateSalePriceWithoutTax: number | null;
    privateDiscountDetails: ProductDiscountDetails | null;
    priceInfos: {
        price: number;
        priceWithoutTax: number;
        crossedOutPrice: number;
        crossedOutPriceWithoutTax: number;
        discountDetails: ProductDiscountDetails | null;
        priceEco: number;
    } | null;
    id: string;
}

export const PriceBlock: VoidFunctionComponent<Props> = ({
    showWithoutTaxOptin,
    setPriceIncludeVAT,
    datePrixBarreMkp,
    soldBy,
    endDateRI,
    priceIncludeVAT,
    eligibilityToPrivateSale,
    privateSalePrice,
    privateSalePriceWithoutTax,
    privateDiscountDetails,
    priceInfos,
    id,
}) => {
    if (!priceInfos) {
        return null
    }

    const priceToDisplay = eligibilityToPrivateSale && privateSalePrice ? privateSalePrice : priceInfos.price;
    const priceToDisplayWithoutTax = eligibilityToPrivateSale && privateSalePriceWithoutTax ? privateSalePriceWithoutTax : priceInfos.priceWithoutTax;
    const discountDetails = eligibilityToPrivateSale && privateDiscountDetails ? privateDiscountDetails : priceInfos.discountDetails;

    const getStringDateToLongText = (dateString: string): string => {
        const parts = dateString.split("/");
        const dateObject = new Date(`${parts[1]}/${parts[0]}/${parts[2]}`);
        return dateObject.toLocaleDateString("fr-FR", {
            year: "numeric",
            month: "long",
            day: "numeric"
        });
    }

    return (
        <div className="all-prices block-layout">
            <div className="price-block ">
                <div className="price-eco">
                    <div className="price">
                        <p>{`${Utils.formatPriceWithoutTax(priceIncludeVAT ? priceToDisplay : priceToDisplayWithoutTax)} €`}</p>
                        {!priceIncludeVAT && <p className="price-ht">HT</p>}
                    </div>
                    {!!priceInfos.priceEco &&
                        <p className="eco">{`dont eco-part. de ${Utils.formatPriceWithoutTax(priceInfos.priceEco)} €`}<br/>{endDateRI ? `jusqu'au ${getStringDateToLongText(endDateRI)}` : ''}</p>
                    }
                </div>
                {showWithoutTaxOptin && <div className="priceVAT-toggle">
                    <Toggle
                        side="right"
                        size="small"
                        checked={!priceIncludeVAT}
                        callBack={(e) => setPriceIncludeVAT(!priceIncludeVAT)}
                        field={id}
                    ><p className="priceVAT-toggle-text">Prix HT</p>
                    </Toggle>
                </div>}
            </div>
            {soldBy === SOLD_BY_MKP && !datePrixBarreMkp && !!discountDetails ? <div className="discount">
                    {!!discountDetails.percentage && <p className="percent">{`${discountDetails.percentage}%`}</p>}
                    <div className='old-price-block'>
                        <p className='old-price'>{`${Utils.formatPriceWithoutTax(priceIncludeVAT ? priceInfos.crossedOutPrice : priceInfos.crossedOutPriceWithoutTax)} €`}</p>
                        {!priceIncludeVAT && <p className='price-ht'>HT</p>}
                    </div>
                </div> :
                (!!priceInfos.crossedOutPrice && !!priceToDisplay
                    && priceInfos.crossedOutPrice > priceToDisplay
                    && !!discountDetails && !!discountDetails.endDate && discountDetails.amount > 0) && (
                    <div className="discount">
                        {!!discountDetails.percentage && <p className="percent">{`${discountDetails.percentage}%`}</p>}
                        <div className='old-price-block'>
                            <p className='old-price'>{`${Utils.formatPriceWithoutTax(priceIncludeVAT ? priceInfos.crossedOutPrice : priceInfos.crossedOutPriceWithoutTax)} €`}</p>
                            {!priceIncludeVAT && <p className='price-ht'>HT</p>}
                        </div>
                        {discountDetails.endDate &&
                            <p className="date">{`jusqu'au  ${getStringDateToLongText(discountDetails.endDate)}`}</p>}
                    </div>
                )}
        </div>
    )
}